<template>
  <div>
    <section class="max-w-7xl mx-auto lg:py-6 py-2 ">
      <h1 class="text-3xl text-gray-700 text-center font-bold p-8  lg:text-3xl text-[20px] sm:text-[20px]">
        Fee Structure
      </h1>
      <div class="mx-auto bg-white rounded-lg shadow-lg text-center p-2 lg:w-full w-[90%] sm:w-[90%]">
        <div class="m-4">
          <!-- Tab content -->
          <div class="tabcontent flex flex-col lg:flex-row">
            <div class="w-full">
              <h1
                class="tablinks align-bottom rounded-t-lg py-4 mt-4 px-4 mx-1 text-white font-semibold text-center bg-[#9D9B9C]"
              >
                Domestic fee structure
              </h1>
              <table class="w-full border-4 border-white">
                <tr class="bg-[#94C34D] text-white h-16">
                    <th class="border-4 border-white">Yearly Fee Plan</th>
                  <th class="border-4 border-white">Total Year  Fee Plan</th>
                </tr>
                <tr class="bg-[#BDE6F7] h-10 text-center">
                  <td class="border-4 border-white">₹ 22,000</td>
                  <td class="border-4 border-white">₹ 66,000</td>
                </tr>
              </table>
            </div>
            <div class="w-full">
              <h1
                class="tablinks align-bottom rounded-t-lg py-4 mt-4 px-4 mx-1 text-white font-semibold text-center bg-[#9D9B9C]"
              >
                International fee structure
              </h1>
              <table class="w-full border-4 border-white">
                <tr class="bg-[#94C34D] text-white h-16">
                  <!-- <th class="border-4 border-white">Semester x 6</th> -->
                  <th class="border-4 border-white">Yearly Fee Plan</th>
                  <th class="border-4 border-white">Total Year  Fee Plan</th>
                </tr>
                <tr class="bg-[#BDE6F7] h-10 text-center">
                  <td class="border-4 border-white">$ 367</td>
                  <td class="border-4 border-white">$ 1100</td>
                  <!-- <td class="border-4 border-white">$ 2,400</td> -->
                </tr>
              </table>
            </div>
          </div>
          <span class="text-sm"><span class="text-red-600">Note:</span> Applicable examination fee per year: <br>
For Indian students: ₹3,000 <br>
For SAARC students: ₹3,000 <br>
For International students: $50</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: () => ({
    activeTab: "tab-1",
  }),
  methods: {
    setActive(tab) {
      this.activeTab = tab;
    },
    isActive(tab) {
      return this.activeTab === tab;
    },
  },
};
</script>

<style>
p{
  margin-bottom: 10px;
}
</style>
